<div class="mat-dialog-containers">
    <mat-icon class="close" (click)="close()">close</mat-icon>
    <div mat-dialog-title class="mat-dialog-title">
        <img style="width: 16rem;" src="assets/imagenes/logo-coomeva.webp">
    </div>
    <div mat-dialog-content class="mat-dialog-content">
        <h4>Generar factura</h4>
        <span>Seleccione la factura que desea generar, y a quien quisiera enviarla</span>
        <br><br>
        <form [formGroup]="frmOptions" style="text-align: center;">
            <mat-form-field style="width: 40%;">
                <mat-label>Factura #</mat-label>
                <mat-select name="billSelected" formControlName="billValue">
                @for (billSelected of billsData; track billSelected) {
                    <mat-option [value]="billSelected.number">{{ billSelected.number }}</mat-option>
                }
                </mat-select>
                <mat-error *ngIf="hasError( getControl['billValue'] )">
                    {{ printError( getControl['billValue'] , {} ) }}
                </mat-error>
            </mat-form-field>
            <mat-radio-group formControlName="selectedOption" class="radio-group" (change)="onSelectionChange($event)">
                <mat-radio-button class="radio-main" color="accent" [value]="'1'">
                    <div class="radio-contain">
                        <span>Contratante:</span>
                        <input #email1Input class="radio-input" matInput type="email" formControlName="emailOwner">
                        <span class="radio-input-error" *ngIf="hasError(getControl['emailOwner'])">
                            {{ printError(getControl['emailOwner'], {'required': 'Ingrese un correo electrónico.', 'correoInvalido':
                             'Ingrese un correo válido.'}) }}
                        </span>
                    </div>
                </mat-radio-button>
                <br>
                <mat-radio-button class="radio-main" color="accent" [value]="'2'">
                    <div class="radio-contain">
                        <span>Asesor:</span>
                        <input #email2Input class="radio-input" matInput type="email" formControlName="emailAsesor">
                        <span class="radio-input-error" *ngIf="hasError(getControl['emailAsesor'])">
                            {{ printError(getControl['emailAsesor'], {'required': 'Ingrese un correo electrónico.', 'correoInvalido':
                             'Ingrese un correo válido.'}) }}
                        </span>
                    </div>
                </mat-radio-button>
            </mat-radio-group>
        </form>
    </div>
    <div mat-dialog-actions class="mat-dialog-actions">
        <div class="mat-dialog-buttons row">
            <button class="btn button-confirm-style" (click)="sendBill()">ENVIAR</button>
            <button class="btn button-confirm-style" (click)="downloadBill()">DESCARGAR</button>
        </div>
        <span class="link-style text-link" [ngClass]="{'text-link-off': !isLocked}" (click)="modifyData()">{{isLocked ?
            "MODIFICAR DATOS" : "CANCELAR"}}</span>
    </div>
</div>